<template>
    <app-card-actions
        :class="classApex"
        no-actions
        :refresh="refresh"
        :flat="flat"
    >
        <template slot="title" v-if="title">
            <span class="align-start">{{title}}</span>
            
        </template>
        
        <template slot="subtitle" v-if="subtitle">
            
            <span class="align-start">{{subtitle}}</span>
        </template>
        <v-card-text :class="classApex">
            <vue-apex-charts
                v-if="!refresh"
                :height="height"
                :options="options"
                :series="localData"
                @click="clickEvent">
            </vue-apex-charts>

        </v-card-text>
        
    
    </app-card-actions>

</template>

<script>
import { ref, watch } from '@vue/composition-api'
import AppCardActions from '@core/components/app-card-actions/AppCardActions.vue'
import VueApexCharts from 'vue-apexcharts'
import { getVuetify } from '@core/utils'

export default ({
    components: {
        AppCardActions,
        VueApexCharts
    },
    props: {
        title: {
            type: String,
            default: () => ''
        },
        subtitle: {
            type: String,
            default: () => ''
        },
        height: {
            type: Number,
            default: () => 400
        },
        classApex: {
            type: String,
            default: () => "mb-7"
        },
        refresh: {
            type: Boolean,
            default: () => false
        },
        flat: {
            type: Boolean,
            default: () => false
        },
        data: {
            type: Array,
            default:() => []
        },
        type: {
            type: String,
            default: () => 'line'
        },
        stacked: {
            type: Boolean,
            default: () => false
        },
        legend: {
            type: Object,
            default: () => {
                return {
                    tooltipHoverFormatter: (val, opts) => {
                        return val
                    }
                }
            }
        },
        tooltip: {
            type: Object,
            default: () => {
                return {
                    enabled: true
                }
            }
        },
        yaxisLabel: {
            type: Function,
            default: () => {return() => {}}
        },
        xaxisLabel: {
            type: Array,
            required:false,
            default: () => []
        },
        stroke: {
            type: Object,
            required:false,
            default: () => {
                return {
                    curve: 'smooth',
                    width: 6,
                    lineCap: 'round'
                }
            }
        },
        plotOptions: {
            type: Object,
            required:false,
            default: () => {
                return {
                }
            }
        }
    },
    setup(props, { emit }) {
        const $vuetify = getVuetify()
        const localData = ref([])
        localData.value = JSON.parse(JSON.stringify(props.data))

        const options = ref({})
        
        const resetOptions = () => {
            const categories = JSON.parse(JSON.stringify(props.xaxisLabel)) || []
            options.value = {
                colors: [
                    $vuetify.theme.currentTheme.primary,
                    $vuetify.theme.currentTheme.success,
                    $vuetify.theme.currentTheme.secondary,
                    $vuetify.theme.currentTheme.accent,
                    $vuetify.theme.currentTheme.info,
                    $vuetify.theme.currentTheme.warning,
                    $vuetify.theme.currentTheme.error,
                    "#0F2F71",
                    "#E74C3C",
                    "#0EAC51",
                    "#DA3C78",
                    "#4CACC8",
                    "#F1892D",
                    "#7E349D",
                    "#0077C0",
                    "#07ABA0",
                    "#FFBBD0",
                    "#FFD966",
                ],
                chart: {
                    height: 350,
                    type: props.type,
                    stacked: props.stacked,
                    zoom: {
                        enabled: true,
                    },
                },
                toolbar: {
                    show: false
                },
                plotOptions: props.plotOptions,
                grid: {
                    strokeDashArray: 7,
                },
                dataLabels: {
                    enabled: false
                },
                stroke:props.stroke,
                xaxis: {
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    categories
                },
                yaxis: {
                    labels: {
                    formatter: value => props.yaxisLabel(value) || value ,
                    offsetX: 5
                    },
                },
                legend:props.legend,
                tooltip:props.tooltip
            
            }
        }

        const clickEvent = (event, chartContext, config) => {
            // console.log(config.globals.initialSeries[0].data[0])
            emit('click-event', config)
        }
        
        resetOptions()

        watch(
            () => props.data,
            () => {
                localData.value = JSON.parse(JSON.stringify(props.data))
                resetOptions()
            }
        )

        return {
            localData,
            options,
            clickEvent
        }
        
    },
    // async mounted()
    // {

    // }
})
</script>
